import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getCurrencySymbol } from '../../../../utils/functions/currencyUtils'
import { OrderCurrencySlice } from './order-currency-types'
import { fetchExchangeRate } from './order-currency-exchange-rate-thunk'

const INITIAL_STATE: OrderCurrencySlice = {
  value: 'USD',
  exchangeRate: 1,
  symbol: '$',
  loading: false,
  error: null,
}

// Create the currency slice
const orderCurrencySlice = createSlice({
  name: 'currency',
  initialState: INITIAL_STATE,
  reducers: {
    setValue: (state, action: PayloadAction<string>) => {
      state.value = action.payload
      state.symbol = getCurrencySymbol(action.payload) || action.payload
    },
    setSymbol: (state, action: PayloadAction<string>) => {
      state.symbol = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExchangeRate.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchExchangeRate.fulfilled, (state, action) => {
        state.loading = false
        state.value = action.payload.value
        state.exchangeRate = action.payload.exchangeRate
        state.symbol = action.payload.symbol
      })
      .addCase(fetchExchangeRate.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const { setValue, setSymbol } = orderCurrencySlice.actions
export default orderCurrencySlice
